function setDocumentTitle(title)
{
    document.title = title
}

export default setDocumentTitle